import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { AuthProvider } from "@/auth/AuthContext";
import { MailboxProvider } from "@/auth/MailboxContext";
import { router } from "@/routes";

import "react-big-calendar/lib/css/react-big-calendar.css";
import "@/index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <MailboxProvider>
          <RouterProvider router={router} />
        </MailboxProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
